import type { ReactNode } from "react";

import { NotFound, type ApiError } from "../../../api/client";
import type { Resource } from "../../../hooks/useResource";

/**
 * What a 404 means on a Labeeb business read.
 *
 * A product 404 is an unconnected business: Labeeb has no record, so there
 * is nothing to show. A gateway 404 (`fromGateway`) is a route that was not
 * mounted. They are different sentences, and neither is an empty list.
 */
export function labeebMissingCopy(error: ApiError): string {
  if (error instanceof NotFound && error.fromGateway) return "The route was not found.";
  return "Labeeb has no record of this business.";
}

/**
 * The `notFound` slot for a Labeeb business read.
 *
 * Other states stay with `ResourceView`. This only answers when the read is
 * already `notfound`, so a page can pass it without enumerating the rest.
 */
export function LabeebMissing({ state }: { state: Resource<unknown> }): ReactNode {
  if (state.kind !== "notfound") return null;
  return (
    <p className="text-sm text-slate-500 dark:text-slate-400">{labeebMissingCopy(state.error)}</p>
  );
}
